import m from "mithril";
import ModalManager from "../../shared/modal";
import UnitUtilities from "../../shared/utilities/unit_utilities";
import Auth from "../../shared/auth";
import i18n from "../../shared/i18n/i18n";

// Modal imports
import Modal_Unit_Scorm_New from "./scorm/modal_unit_scorm_new";
import Modal_Unit_Form_New from "./form/modal_unit_form_new";
import Modal_Unit_Event_New from "./event/modal_unit_event_new";
import Modal_Unit_Certificate_New from "./certificate/modal_unit_certificate_new";
import Modal_Unit_Document_New from "./document/modal_unit_document_new";
import Modal_Unit_Action_New from "./action/modal_unit_action_new";
import Modal_Unit_Approval_New from "./approval/modal_unit_approval_new";
import Modal_Unit_Download_New from "./download/modal_unit_download_new";
import Modal_Unit_Upload_New from "./upload/modal_unit_upload_new";
import Modal_Unit_Assessment_New from "./assessment/modal_unit_assessment_new";
import {UnitTypes} from "../values";

let modalId;

// 🧩 Define all unit types in one place
const unitCreateMap = [
    { type: UnitTypes.scorm, claim: "unit_scorm_create", modal: Modal_Unit_Scorm_New, title: "create_interactive_unit" },
    { type: UnitTypes.form, claim: "unit_form_create", modal: Modal_Unit_Form_New, title: "create_form_unit" },
    { type: UnitTypes.assessment, claim: "unit_assessment_create", modal: Modal_Unit_Assessment_New, title: "create_assessment_unit" },
    { type: UnitTypes.event, claim: "unit_event_create", modal: Modal_Unit_Event_New, title: "create_face_to_face_unit" },
    { type: UnitTypes.cert, claim: "unit_certificate_create", modal: Modal_Unit_Certificate_New, title: "create_certificate_unit" },
    { type: UnitTypes.doc, claim: "unit_document_create", modal: Modal_Unit_Document_New, title: "create_document_unit" },
    // { type: "action", claim: "unit_action_create", modal: Modal_Unit_Action_New, title: "create_action_unit" }, // Uncomment when needed
    { type: UnitTypes.approval, claim: "unit_approval_create", modal: Modal_Unit_Approval_New, title: "create_approval_unit" },
    { type: UnitTypes.download, claim: "unit_download_create", modal: Modal_Unit_Download_New, title: "create_download_unit" },
    { type: UnitTypes.upload, claim: "unit_upload_create", modal: Modal_Unit_Upload_New, title: "create_upload_unit" }
];

// 🧠 Launch unit creation modal
function launchUnit(modalComponent, titleKey) {
    ModalManager.open(i18n.t(titleKey), [], modalComponent);
    ModalManager.close(modalId);
}

const Modal_Unit_New = {
    view: function () {
        return unitCreateMap.map(entry => {
            const icon = UnitUtilities.getUnitTypeIcon(entry.type);
            const name = UnitUtilities.getUnitTypeName(entry.type);
            const disabled = !Auth.validateRights([entry.claim]);

            return m("button.with-icon.btn-big", {
                class: disabled ? "disabled" : "",
                onclick: () => !disabled && launchUnit(entry.modal, entry.title)
            }, [
                m("i", { class: icon }),
                name
            ]);
        });
    },
    setModalId: function (id) {
        modalId = id;
    }
};

export default Modal_Unit_New;
